import entryPoint from '../../constants/endpoints';
import sessionFetch from '../../middleware/sessionFetch';

// Все компании с телефонами — для предупреждения о повторном номере в форме компании. Форма
// загружает их сама: список компаний в памяти есть только после страницы «Список компаний»,
// а форму могут открыть и сразу. При ошибке загрузки (null) форма берёт то, что уже есть в памяти.
export const loadCompanyPhones = async () => {
  try {
    const response = await sessionFetch(`${entryPoint}/companylist`);
    if (!response.ok) return null;
    const rows = await response.json();
    return Array.isArray(rows)
      ? rows.map((row) => ({ id: row.id, name: row.name, phoneNumber: row.phoneNumber }))
      : null;
  } catch (err) {
    return null;
  }
};
